export Search from './components/Component';
export reducer from './reducer';
export SearchSideBar from './components/SearchSidebar';



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/index.js
 **/